import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { GrpcHandler, GrpcInterceptor } from '@ngx-grpc/core';
import { GrpcMessage, GrpcRequest, GrpcEvent } from '@ngx-grpc/common';
import { StorageService } from '../../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterseptorService implements GrpcInterceptor {
  constructor(private injector: Injector) {} 

  intercept<Q extends GrpcMessage, S extends GrpcMessage>(
    request: GrpcRequest<Q, S>,
    next: GrpcHandler
  ): Observable<GrpcEvent<S>> {
    const authService = this.injector.get(AuthService); 
    const router = this.injector.get(Router);
    const storageService = this.injector.get(StorageService);           

    // If there's no token (first-time login), we must allow the request to proceed.
    // Without this check, even the login request would be blocked by the interceptor.
    const token = authService.getToken();
    if (!token) {
      return next.handle(request); 
    }

    if (authService.hasTokenExpired()) {
      console.warn('gRPC Token expired. Redirecting...');
      storageService.clear();
      router.navigate(['/authentication']);
      
      return EMPTY;
    }

    return next.handle(request);
  }
}

